import { Component, input, OnInit } from '@angular/core';
import { OfferingAddonDetail } from '../../../models/offering';
import {
  RdsTableModule,
  RdsBadgeModule,
  RdsTableDataSource,
  RdsLinkModule,
} from '@rds/angular-components';
import { RouterModule } from '@angular/router';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';

@Component({
  selector: 'inexp-offering-addons',
  imports: [RdsTableModule, RdsBadgeModule, RdsLinkModule, RouterModule],
  templateUrl: './offering-addons.component.html',
  styleUrl: './offering-addons.component.scss',
})
export class OfferingAddonsComponent implements OnInit {
  addonDetails = input<OfferingAddonDetail[]>([]);
  _uid = input<string>();
  component = input<string>();
  section = input<string>();

  readonly addonDataSource =
    new RdsTableDataSource<OfferingAddonDetail>().init();

  readonly addonColumns = ['name', 'description', 'cost', 'support', 'url'];

  BUTTONS = BUTTON_TEXTS;

  ngOnInit() {
    this.addonDataSource.data = this.addonDetails();
  }
}
